export function formatMs(ms: number) {
  const s = Math.max(0, Math.floor(ms / 1000))
  const h = Math.floor(s / 3600)
  const m = Math.floor((s % 3600) / 60)
  return h > 0 ? `${h}h ${m}m` : `${m}m`
}

export function formatDateTime(v?: string | null) {
  if (!v) return "—"
  const d = new Date(v)
  if (Number.isNaN(d.getTime())) return "—"
  return d.toLocaleString()
}

export function formatAgo(now: number, iso?: string | null) {
  if (!iso) return "—"
  const t = new Date(iso).getTime()
  if (!t) return "—"
  const diff = now - t
  if (diff <= 0) return "just now"
  return `${formatMs(diff)} ago`
}

export function safeTimeMs(iso?: string | null) {
  if (!iso) return 0
  const t = new Date(iso).getTime()
  return Number.isFinite(t) ? t : 0
}
